(() => {
  const hasGRPAncestor = (node) => {
    if (!node || node.nodeType !== 1) return false;
    const el = node;
    return !!el.closest('[class*="grp_"], [class*="grp-"], [id*="grp"]');
  };

  const sanitize = (s) => {
    if (!s) return s;

    return s
      .replace(/\bWrite a Review\b/gi, "Écrire un avis")
      .replace(/\bRead More\b/gi, "En savoir plus")
      .replace(/\bShow all Reviews\b/gi, "Afficher tous les avis")
      .replace(/\bon Google\b/gi, "")
      .replace(/\bago\b/gi, "")
      .replace(/\b(year|years|month|months|week|weeks|day|days)\b/gi, "")
      .replace(/\s{2,}/g, " ")
      .replace(/\s+\./g, ".")
      .trim();
  };

  const processRoot = (root) => {
    if (!root) return;

    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    const targets = [];
    while (walker.nextNode()) {
      const n = walker.currentNode;
      const t = (n.nodeValue || "").trim();
      if (!t) continue;

      if (
        /Write a Review|Read More|Show all Reviews|on Google|\bago\b|\b(year|month|week|day)s?\b/i.test(t)
      ) {
        targets.push(n);
      }
    }

    for (const n of targets) n.nodeValue = sanitize(n.nodeValue);

    root.querySelectorAll("[aria-label],[title]").forEach((el) => {
      const aria = el.getAttribute("aria-label");
      const title = el.getAttribute("title");
      if (aria) el.setAttribute("aria-label", sanitize(aria));
      if (title) el.setAttribute("title", sanitize(title));
    });
  };

  const findWidgetRoots = () => {
    const roots = new Set();
    document.querySelectorAll('[class*="grp_"], [class*="grp-"], [id*="grp"]').forEach((el) => {
      const txt = (el.textContent || "");
      if (/Write a Review|Show all Reviews|on Google|Read More|Avis Google|Google/i.test(txt)) {
        roots.add(el);
      }
    });
    return Array.from(roots);
  };

  const initial = () => {
    findWidgetRoots().forEach(processRoot);
  };

  initial();

  const obs = new MutationObserver((mutations) => {
    for (const m of mutations) {
      for (const node of m.addedNodes) {
        if (!node || node.nodeType !== 1) continue;
        const el = node;

        if (hasGRPAncestor(el) || el.querySelector?.('[class*="grp_"], [class*="grp-"], [id*="grp"]')) {
          const roots = [el, ...findWidgetRoots()];
          roots.forEach(processRoot);
        }
      }
    }
  });

  obs.observe(document.documentElement, { childList: true, subtree: true });
  setTimeout(() => obs.disconnect(), 20000);
})();
